import { combineReducers } from "@reduxjs/toolkit";
import authReducer from "./slices/authSlice";
import userReducer from "./slices/userSlice";
import vehicleReducer from './slices/vehicleSlice'
import settingReducer from './slices/settingslice'
import adminReducer from './slices/adminSlice'

const rootReducer = combineReducers({
  auth: authReducer,
  user: userReducer,
  vehicle: vehicleReducer,
  setting: settingReducer,
  admin: adminReducer
});

export default rootReducer;